import { StickyButton } from "./styles";
import { useGoogleAnalyticsContext } from "contexts";
import stickyBackToGameIcon from "assets/icon-back-to-game.png";
import { useLinks } from "hooks/useLinks";

interface StickyBackToGameButtonProps {
	styles?: React.CSSProperties;
	source: string;
	onClick?: () => void;
	className?: string;
}

const StickyBackToGameButton = ({
	styles,
	source,
	onClick,
	className
}: StickyBackToGameButtonProps) => {
	const links = useLinks();
	const { analytics_key, path } = links.back_to_game;
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();

	const handleClick = () => {
		reportEvent(analytics_key, { source: source });
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: analytics_key,
			event_type: source,
			action: analytics_key,
			source
		});
		window?.open(path, "_blank");
		onClick?.();
	};

	return (
		<StickyButton
			className={className}
			onClick={handleClick}
			style={{ ...styles }}
		>
			<img src={stickyBackToGameIcon} alt="Back to game button" />
		</StickyButton>
	);
};

export default StickyBackToGameButton;
